import { gql } from "@apollo/client";

export const RETRIEVE_ATTACHMENTS = gql`
  mutation retrieveAttachments($input: RetrieveAttachmentsInput!) {
    retrieveAttachments(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_ATTACHMENT = gql`
  mutation updateAttachment($input: UpdateAttachmentInput!) {
    updateAttachment(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_ATTACHMENTS = gql`
  mutation addAttachments($input: AddAttachmentsInput!) {
    addAttachments(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation deleteAttachment($input: DeleteAttachmentInput!) {
    deleteAttachment(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const CHANGE_ATTACHMENT_STATE = gql`
  mutation changeAttachmentState($input: ChangeAttachmentStateInput!) {
    changeAttachmentState(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const COMPUTE_REQUIRED_DOC_TYPES = gql`
  mutation computeRequiredDocTypes($input: ComputeRequiredDocTypesInput!) {
    computeRequiredDocTypes(input: $input) {
      commandId
      correlationId
    }
  }
`;
